import * as React from "react";
import {AsyncAjax} from "../../../Shared/AsyncAjax";
import {ListGroup, ListGroupItem} from "react-bootstrap";
import {PlayerHeader} from "./PlayerItemList";
declare var smartformsrecordingparams:any;


export class PlayerItem  extends React.Component<PlayerItemProps,PlayerItemState>{
    public $Container:JQuery;
    constructor(){
        super();
        this.state={

        };

    }



    render(){

        let child;
        if(this.props.item==null)
            child=(   [<img key='img' src={smartformsrecordingparams.pluginUrl+'img/loadingSmall.gif'}/>,
                <h3 key="h3" style={{verticalAlign:'middle', display:'inline'}}>  Loading Recorded Sessions</h3>]);
        else
            child=([
                <p key='p1'><span title="URL" className="glyphicon glyphicon-link"></span> {this.props.item.url==''?'/':this.props.item.url}</p>,
                <p key='p2'><span title="Recording Date" className="glyphicon glyphicon-calendar"></span> {this.MillisecondsToDate(this.props.item.start_time)}</p>,
                <p key='p3'><span title="Duration" className="glyphicon glyphicon-time"></span> {this.MillisecondsToDuration(this.props.item.duration)}</p>
                ]);


       return (<a href="#a" onClick={this.props.onClick} ref={(node)=>this.$Container=jQuery(node)} className={'list-group-item '+this.props.className}>
           {child}
        </a>);

    }


    private MillisecondsToDate(start_time: string) {
        let date=new Date(parseInt(start_time));
        let monthName;
        switch (date.getMonth())
        {
            case 0:
                monthName='January';
                break;
            case 1:
                monthName='February';
                break;
            case 2:
                monthName='March';
                break;
            case 3:
                monthName='April';
                break;
            case 4:
                monthName='May';
                break;
            case 5:
                monthName='June';
                break;
            case 6:
                monthName='July';
                break;
            case 7:
                monthName='August';
                break;
            case 8:
                monthName='September';
                break;
            case 9:
                monthName='October';
                break;
            case 10:
                monthName='November';
                break;
            case 11:
                monthName='December';
        }


        return monthName+'-'+this.FormatTimeSection(date.getDate())+'-'+date.getFullYear()+' '+this.FormatTimeSection(date.getHours())+':'+this.FormatTimeSection(date.getMinutes())+":"+this.FormatTimeSection(date.getSeconds());
    }

    private FormatTimeSection(time:number)
    {
        if(time>=10)
            return time;
        return '0'+time.toString();

    }

    private MillisecondsToDuration(st: string) {
        let start_time:number=parseInt(st);
        let ms = start_time % 1000;
        start_time = (start_time - ms) / 1000;
        let secs = start_time % 60;
        start_time = (start_time - secs) / 60;
        let mins = start_time % 60;
        let hrs = (start_time - mins) / 60;

        return this.FormatTimeSection(hrs) + ':' + this.FormatTimeSection(mins) + ':' + this.FormatTimeSection(secs);
    }
}


//<editor-fold desc="DTO">
interface PlayerItemState{

}

interface PlayerItemProps{
    item:PlayerHeader;
    onClick:(node:any)=>void;
    className:string;

}



// WEBPACK FOOTER //
// ./React/Screens/Player/PlayerItem.tsx